import React, { useEffect, useRef, useCallback, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { Container } from 'react-bootstrap';

import { differenceInYears, format, parseISO } from 'date-fns';

import { useToast } from '../../hooks/toast';
import { useAuth } from '../../hooks/auth';

import Input from '../../components/Input';
import { IOption } from '../../components/SelectSync';

import Select from '../../components/Select';

import Modal from '../../components/Modal';
import Button from '../../components/Button';

import getValidationErrors from '../../utils/getValidationErrors';
import api from '../../services/api';
import Loading from '../../components/Loading';
import ListaAtendimentoExame from '../../components/ListaAtendimentoExame';
import ListaAtendimentoConsulta from '../../components/ListaAtendimentoConsulta';
import {
  formataTelefone,
  statusAgendamento,
  STATUS_AGENDA,
  TIPO_USUARIO,
  formataIdade,
} from '../../utils/funcoes';
import { ISendMessage } from '../../components/Chat';
import socket from '../../services/socket';
import Historico from '../../components/Historico';
import getResponseErrors from '../../utils/getResponseErrors';
import Toggle from '../../components/Exame/Toggle';
import {
  IListagemAgendas,
  IRetornoListagemAgenda,
} from '../AgendaCadastro/ListaAgendas';
import { IAgendaSala } from '../AgendaSalas';

export interface IFormBusca {
  dataBusca: string;
  agenda: string;
  somenteLista: string;
}

export interface IListaAgendamentosHojeDTO {
  PacNome: string;
  PacNomeSocial: string;
  PacCodigo: number;
  PacTelefone: string;
  PacCelular: string;
  PacDataNasc: Date;
  AgeCodigo: number;
  AgeDataLiberacao: Date;
  AgeInicio: Date;
  AgeFim: Date;
  AgeStatus: number;
  AgeObsMedico: string;
  AgeConfirmado: number;
  ConIntegracao: boolean;
  ConNome: string;
  ConvNome: string;
  Procedimento: string;
  CprDataBaixa: Date;
  horario?: string;
  liberado?: string;
  celular?: string;
  telefone?: string;
  icone?: { id: number; nome: string; color: string; icon: string };
  atendido: boolean;
  ExaCodOS?: string;
  codItens?: string;
  id?: number;
  idade?: string;
  idadeNumero?: number;
  MedNome?: string;
  MedNumeroConselho?: string;
  MedUF?: string;
  solicitante: string;
}

export interface IFilaChamado {
  AgeCodigo: number;
  PacCodigo: number;
  PacNome: string;
  Sala: string;
  Texto: string;
  Arquivo?: string;
  created_at?: Date;
}

const Atendimento: React.FC = () => {
  const location = useLocation();
  const history = useHistory();
  function useQuery(): URLSearchParams {
    return new URLSearchParams(location.search);
  }

  const query = useQuery();

  const { addToast } = useToast();
  const { user, clinica } = useAuth();
  const [loading, setLoading] = useState(false);
  const [listaEspera, setListaEspera] = useState<IListaAgendamentosHojeDTO[]>(
    [],
  );
  const [totalAtendido, setTotalAtendido] = useState<number>();

  const formRefBusca = useRef<FormHandles>(null);

  const [optionsAgenda, setOptionsAgenda] = useState<IOption[]>([]);
  const [agendas, setAgendas] = useState<IListagemAgendas[]>([]);
  const [integracao, setIntegracao] = useState(0);
  const [showModalHistorico, setShowModalHistorico] = useState(false);
  const [pacienteSelecionado, setPacienteSelecionado] = useState<
    number | undefined
  >(undefined);

  const [exibeAgendaCompleta, setExibeAgendaCompleta] = useState(false);
  const [nomeSala, setNomeSala] = useState('');

  const [dadosBusca, setDadosBusca] = useState(() => {
    return {
      codigoAgenda: query.get('agenda') || undefined,
      dataAgenda: query.get('data') || format(new Date(), 'yyyy-MM-dd'),
      somenteLista: query.get('somenteLista')
        ? query.get('somenteLista') === 'true'
        : true,
      atualiza: format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
    };
  });

  useEffect(() => {
    const handleNewAtendimento = (codAgenda: number): void => {
      if (
        dadosBusca.codigoAgenda &&
        codAgenda === Number(dadosBusca.codigoAgenda)
      )
        formRefBusca.current?.submitForm();
    };

    socket.on('atendimento', handleNewAtendimento);
    return () => {
      socket.removeEventListener('atendimento', handleNewAtendimento);
    };
  }, [dadosBusca.codigoAgenda]);

  useEffect(() => {
    async function loadAgendas(): Promise<void> {
      setLoading(true);
      try {
        const response = await api.get<IRetornoListagemAgenda>(
          `listagemAgendas?UsuCodigo=${user.UsuCodigo}&ConAtivo=true&ConAtende=true&limite=30`,
        );

        setAgendas(response.data.agendas);
        const listagemAgendasApi: IListagemAgendas[] = response.data.agendas;

        const options: IOption[] = listagemAgendasApi.map(lista => {
          return {
            label: `${lista.CliNomeAbreviado} / ${lista.ConNome}`,
            value: lista.ConCodigo.toString(),
          };
        });

        setOptionsAgenda(options);

        if (!dadosBusca.codigoAgenda) {
          if (listagemAgendasApi.length > 0) {
            setDadosBusca(state => {
              return {
                ...state,
                somenteLista: !listagemAgendasApi[0].ConMedicoAgendaCompleta,
              };
            });

            if (listagemAgendasApi[0].ConMedicoAgendaCompleta !== undefined)
              setExibeAgendaCompleta(
                listagemAgendasApi[0].ConMedicoAgendaCompleta,
              );
          }
        } else {
          const exibiCompleta =
            listagemAgendasApi.find(
              con => con.ConCodigo === Number(dadosBusca.codigoAgenda),
            )?.ConMedicoAgendaCompleta || false;
          setExibeAgendaCompleta(exibiCompleta);
        }
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível listar agendas',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    }
    if (user.UsuTipo !== TIPO_USUARIO.MEDICO) {
      history.push('/dashboard');
    } else {
      loadAgendas();
    }
  }, [
    user.UsuCodigo,
    user.UsuTipo,
    addToast,
    history,
    dadosBusca.codigoAgenda,
  ]);

  const initialData = {
    dataBusca: dadosBusca.dataAgenda,
    agenda: dadosBusca.codigoAgenda || '',
    somenteLista: dadosBusca.somenteLista,
  };

  useEffect(() => {
    if (dadosBusca.codigoAgenda) {
      const ag = agendas.find(
        (agen: IListagemAgendas) =>
          agen.ConCodigo === Number(dadosBusca.codigoAgenda),
      );
      if (ag) setIntegracao(ag.ConIntegracao);
    } else if (agendas[0]) setIntegracao(agendas[0].ConIntegracao);
  }, [agendas, dadosBusca]);

  const handleSubmitBusca = useCallback(async (dados: IFormBusca) => {
    formRefBusca.current?.setErrors({});
    const schema = Yup.object().shape({
      dataBusca: Yup.date()
        .typeError('Digite uma data válida')
        .required('Obrigatório'),
      agenda: Yup.number()
        .min(1, 'Selecione uma agenda')
        .typeError('Selecione uma agenda')
        .required('Obrigatório'),
    });

    await schema.validate(dados, {
      abortEarly: false,
    });

    setDadosBusca({
      codigoAgenda: dados.agenda,
      dataAgenda: dados.dataBusca,
      somenteLista: dados.somenteLista.toString() === 'true',
      atualiza: format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
    });
  }, []);

  useEffect(() => {
    async function buscarLista(): Promise<void> {
      let sala = '';
      try {
        setLoading(true);
        setNomeSala(sala);
        const responseSala = await api.get<IAgendaSala>(
          `/salas/${dadosBusca.codigoAgenda}`,
        );

        sala = responseSala.data.NomeSala;
        setNomeSala(sala);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
      setLoading(true);
      try {
        const response = await api.get<IListaAgendamentosHojeDTO[]>(
          `atendimentos/emespera?ConCodigo=${
            dadosBusca.codigoAgenda
          }&Data=${format(
            parseISO(dadosBusca.dataAgenda),
            'yyyy-MM-dd',
          )}&AgeCompleta=${
            exibeAgendaCompleta
              ? !(dadosBusca.somenteLista.toString() === 'true')
              : false
          }`,
        );
        if (response.data.length === 0) setListaEspera([]);

        const retornoFormatado = response.data.map(lista => ({
          ...lista,
          idade: formataIdade(parseISO(lista.PacDataNasc.toString())),
          idadeNumero: differenceInYears(
            new Date(),
            parseISO(lista.PacDataNasc.toString()),
          ),
          horario: format(parseISO(lista.AgeInicio.toString()), 'HH:mm'),
          liberado: lista.AgeDataLiberacao
            ? format(parseISO(lista.AgeDataLiberacao.toString()), 'HH:mm')
            : '',
          celular: formataTelefone(lista.PacCelular),
          telefone: formataTelefone(lista.PacTelefone),
          icone: statusAgendamento.find(
            status => status.id === Number(lista.AgeStatus),
          ),
          atendido: lista.AgeStatus === STATUS_AGENDA.ATENDIDO,
          solicitante: lista.MedNome
            ? `${lista.MedNome || ''} CRM ${lista.MedNumeroConselho || ''} ${
                lista.MedUF || ''
              }`
            : '',
        }));
        setListaEspera(retornoFormatado);
        const totalAtendid = response.data.filter(
          age => age.AgeStatus === STATUS_AGENDA.ATENDIDO,
        );
        setTotalAtendido(totalAtendid.length || 0);
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRefBusca.current?.setErrors(errors);
        } else {
          const mensagemErro = getResponseErrors(error);
          addToast({
            title: 'Não foi possível carregar lista de espera',
            type: 'error',
            description: mensagemErro,
          });
        }
      } finally {
        setLoading(false);
      }
    }

    if (dadosBusca.codigoAgenda) buscarLista();
  }, [
    dadosBusca,
    history,
    location.search,
    addToast,
    exibeAgendaCompleta,
    clinica.CliUsaPainel,
  ]);

  const handleOnChange = useCallback(
    event => {
      const ag = agendas.find(
        (agen: IListagemAgendas) =>
          agen.ConCodigo === Number(event.target.value),
      );

      if (ag) {
        setDadosBusca(state => {
          return {
            ...state,
            codigoAgenda: ag.ConCodigo.toString(),
            ...(ag.ConMedicoAgendaCompleta ? {} : { somenteLista: true }),
          };
        });
        setExibeAgendaCompleta(ag.ConMedicoAgendaCompleta);
        setIntegracao(ag.ConIntegracao);
      }
    },
    [agendas],
  );

  const handleTogleOnChange = useCallback(valor => {
    setDadosBusca(state => {
      return {
        ...state,
        somenteLista: valor,
      };
    });
  }, []);

  const handleChamarPacientePainel = useCallback(
    async (dados: IFilaChamado) => {
      try {
        setLoading(true);

        await api.post<IFilaChamado>(`/filaChamados`, dados);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  const handleChamarPaciente = useCallback(
    (pacNome: string) => {
      const mensagem: ISendMessage = {
        clinica: user.UsuClinica.toString(),
        from: user.UsuNome,
        idFrom: user.UsuCodigo,
        to: 'chamar_paciente',
        idTo: 0,
        mensagem:
          clinica.CliUsaPainel && nomeSala !== ''
            ? `${pacNome}, ${nomeSala}`
            : `Chamar Paciente ${pacNome}`,
        lida: false,
        created_at: new Date(),
        painel: clinica.CliUsaPainel,
      };
      socket.emit('chamar_paciente', mensagem);
    },
    [user, clinica.CliUsaPainel, nomeSala],
  );

  const handleHistorico = useCallback(pacCodigo => {
    setPacienteSelecionado(pacCodigo);
    setShowModalHistorico(true);
  }, []);

  const handleFecharHistorico = useCallback(() => {
    setPacienteSelecionado(undefined);
    setShowModalHistorico(false);
  }, []);

  return (
    <Container fluid className="mt-2">
      {loading && <Loading backgroundBlack={false} />}
      <>
        {showModalHistorico && (
          <Modal
            show={showModalHistorico}
            titulo="Historico"
            handleFecharModal={handleFecharHistorico}
            large
          >
            {pacienteSelecionado && (
              <Historico pacCodigo={pacienteSelecionado} />
            )}
          </Modal>
        )}
        {optionsAgenda.length > 0 ? (
          <>
            <div className="bg-white border p-2 mb-2">
              <Form
                ref={formRefBusca}
                initialData={initialData}
                onSubmit={handleSubmitBusca}
              >
                <div className="row">
                  <div className="col-md-2 form-group">
                    <Input
                      name="dataBusca"
                      label="Data"
                      placeholder=""
                      type="date"
                    />
                  </div>
                  <div className="col-md-5 form-group">
                    <Select
                      name="agenda"
                      label="Agenda"
                      placeholder="Selecione"
                      options={optionsAgenda}
                      onChange={handleOnChange}
                    />
                  </div>
                  <div className="col-md-2 form-group">
                    <div className={`${!exibeAgendaCompleta && 'd-none'}`}>
                      <Toggle
                        nome="somenteLista"
                        label="Somente em espera"
                        isDisabled={!exibeAgendaCompleta}
                        handleOnChange={handleTogleOnChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="input-group-append mt-3">
                      <Button type="submit" variant="secondary-outline">
                        BUSCAR
                      </Button>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
            <span className={`py-2 ${clinica.CliUsaPainel ? '' : 'd-none'}`}>
              {nomeSala === '' ? 'Sem consultório configurado' : nomeSala}
            </span>
            <div className="bg-white border p-2">
              {listaEspera.length > 0 ? (
                <>
                  <span className="d-block text-right">
                    Total Atendidos: <b>{totalAtendido}</b>
                  </span>
                  {integracao === 1 ? (
                    <ListaAtendimentoExame
                      dadosBusca={dadosBusca}
                      listaEspera={listaEspera}
                      chamar={handleChamarPaciente}
                      chamarPainel={handleChamarPacientePainel}
                      abrirHistorico={handleHistorico}
                      sala={nomeSala}
                    />
                  ) : (
                    <ListaAtendimentoConsulta
                      dadosBusca={dadosBusca}
                      listaEspera={listaEspera}
                      chamar={handleChamarPaciente}
                      chamarPainel={handleChamarPacientePainel}
                      abrirHistorico={handleHistorico}
                      sala={nomeSala}
                    />
                  )}
                </>
              ) : (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ minHeight: '250px' }}
                >
                  <h5>Nenhum paciente na lista de espera</h5>
                </div>
              )}
            </div>
          </>
        ) : (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '5%',
            }}
          >
            <span>
              <h3>
                Médico não possui agenda configurada para atender em consultório
              </h3>
            </span>
          </div>
        )}
      </>
    </Container>
  );
};

export default Atendimento;
